import { relations } from 'drizzle-orm';
import { tenants } from '../models/tenants';
import { roles } from '../models/roles';
import { users } from '../models/users';
import { tenantUsers } from '../models/tenantUsers';

/**
 * @group Tenant
@summary Tenant relations for the database schema
@remarks
Defines the one-to-many relationship between tenants and roles.
@example
```typescript
import { tenantRelations } from '@shared/db';
// Query tenant with roles
const tenantWithRoles = await db.query.tenants.findFirst({
  where: eq(tenants.id, tenantId),
  with: {
    roles: true
  }
});
```
 * @internal
 */
export const tenantRelations = relations(tenants, ({ one, many }) => ({
  user: one(users, {
    fields: [tenants.user_id],
    references: [users.id],
  }),
  roles: many(roles),
  tenantUsers: many(tenantUsers),
})); 